var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerificationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 73,
    viewBox: "0 0 78 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8819 58.2458C22.8819 42.9943 33.6861 30.3074 47.9424 27.6513C44.1561 25.9476 39.9669 25 35.5597 25C18.65 25 4.94238 38.9271 4.94238 56.1074V73H22.8807V58.2458H22.8819Z",
    fill: "#F8B400",
    fillOpacity: 0.37
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.072 11.5C31.072 6.83122 33.955 2.87493 37.9424 1.50987C36.9766 1.17979 35.9469 1 34.8776 1C29.3906 1.00095 24.9424 5.70112 24.9424 11.5C24.9424 17.2989 29.3906 22 34.8776 22C35.9469 22 36.9766 21.8202 37.9424 21.4901C33.955 20.1251 31.072 16.1688 31.072 11.5Z",
    fill: "#F8B400",
    fillOpacity: 0.37
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.252 57.6895V72.2114",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50952 72.2118V55.4283C7.50952 38.9305 20.8833 25.5566 37.3812 25.5566C47.6923 25.5566 56.7835 30.7804 62.1506 38.727",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3814 22.3678C31.5206 22.3678 26.7258 17.573 26.7258 11.7122C26.7258 5.85142 31.5206 1.05664 37.3814 1.05664C43.2422 1.05664 48.037 5.85142 48.037 11.7122C48.0358 17.573 43.2411 22.3678 37.3814 22.3678Z",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0317 39.0596H75.3557C76.394 39.0596 77.2357 39.9013 77.2357 40.9396V55.8095C77.2357 56.8478 76.394 57.6895 75.3557 57.6895H33.9347C32.8964 57.6895 32.0547 56.8478 32.0547 55.8095V51.2344",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0547 46.3124V40.9396C32.0547 39.9013 32.8964 39.0596 33.9347 39.0596H47.3108",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.223 46.3135H48.4288L45.899 51.8563H45.7117L43.1912 46.3135H43.4062L45.8053 51.6205L48.223 46.3135Z",
    fill: "#005555",
    stroke: "#005555",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7308 46.4545H49.6946V49.0132H52.4499V49.1554H49.6946V51.7141H52.7308V51.8563H49.5073V46.3135H52.7308V46.4545Z",
    fill: "#005555",
    stroke: "#005555",
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6445 46.3135C57.1441 46.3135 57.7904 46.9517 57.7904 47.872C57.7904 48.7693 57.1718 49.3208 56.0561 49.4237L57.8366 51.8563H57.6019L55.8399 49.4387C55.7832 49.4387 55.7185 49.4387 55.6618 49.4387H54.1807V51.8563H53.9934V46.3135H55.6445ZM55.6445 46.4707H54.183V49.2895H55.6641C57.0134 49.2895 57.595 48.6837 57.595 47.872C57.5938 47.0141 57.0597 46.4707 55.6445 46.4707Z",
    fill: "#005555",
    stroke: "#005555",
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.009 46.3135H59.1963V51.8563H59.009V46.3135Z",
    fill: "#005555",
    stroke: "#005555",
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7886 46.3135H64.0121V46.4557H60.9759V49.0144H63.7311V49.1566H60.9759V51.8575H60.7886V46.3135Z",
    fill: "#005555",
    stroke: "#005555",
    strokeWidth: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1843 46.3135H65.3716V51.8563H65.1843V46.3135Z",
    fill: "#005555",
    stroke: "#005555",
    strokeWidth: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1883 46.4545H67.1521V49.0132H69.9074V49.1554H67.1521V51.7141H70.1883V51.8563H66.9648V46.3135H70.1883V46.4545Z",
    fill: "#005555",
    stroke: "#005555",
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6724 49.0849C76.6724 50.8331 75.4827 51.8563 73.1865 51.8563H71.4521V46.3135H73.1865C75.4827 46.3135 76.6724 47.3367 76.6724 49.0849ZM73.1865 51.7141C75.3983 51.7141 76.4851 50.7059 76.4851 49.0837C76.4851 47.4616 75.3983 46.4534 73.1865 46.4534H71.6406V51.713H73.1865V51.7141Z",
    fill: "#005555",
    stroke: "#005555",
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0867 46.1291L35.5753 52.2535L55.5244 34.5127",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.772 23.3184V24.8584",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7179 25.5098H16.4333",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1999 25.5098H13.9165",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.772 26.2549V27.7949",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0969 9.47461V11.0135",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0429 11.666H56.7595",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5246 11.666H54.2412",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0969 12.4111V13.95",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0828 60.4756V62.0145",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0288 62.667H73.7454",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5104 62.667H71.2271",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0828 63.4121V64.951",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8562 57.5381V59.077",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80219 59.7275H3.5188",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M2.28503 59.7275H1.00049",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8562 60.4746V62.0135",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationIcon);
export default __webpack_public_path__ + "static/media/verificationIcon.cb0312992fdf79747c380ac1b76d2c83.svg";
export { ForwardRef as ReactComponent };